import { useEffect, useState } from "react";
import { useAppSelector } from "../redux/hook";
import { useGetEligibilityOverrideByHdbRefQuery } from "../redux/services/getEligibilityOverride";
import { EligibilityCheck } from "../models/classes/EligibilityOverride.class";

interface BypassSolicitorInterface {
    current: boolean;
    proposed: boolean;
}

interface BypassPaymentInterface {
    admin: boolean;
    valuation: boolean;
}

interface BypassConsentInterface {
  uinfin: string;
  consent_check: boolean;
}

function useGetEligibilityOverride(hdbRef?: string) {
  const loginUser = useAppSelector(
    (state) => state.auth.AuthenticationSlice.loginUser
  );
  const singpassToken = useAppSelector(
    (state) => state.auth.AuthenticationSlice.singpassToken
  );
  const { data: eligibilityOverrideResponse, isSuccess } = useGetEligibilityOverrideByHdbRefQuery({uinfin: loginUser?.uinfin ?? "", singpass_token: singpassToken ?? "", hdbRef: hdbRef!});
  
  const [ bypassSolicitors, setBypassSolicitors ] = useState<BypassSolicitorInterface>({current: false, proposed: false});
  const [ bypassPayments, setBypassPayments ] = useState<BypassPaymentInterface>({admin: false, valuation: false});

  useEffect(() => {
    if (!eligibilityOverrideResponse) return;
    
    setBypassSolicitors({
        current: eligibilityOverrideResponse?.current_household_solicitor === EligibilityCheck.BYPASS,
        proposed: eligibilityOverrideResponse?.proposed_household_solicitor === EligibilityCheck.BYPASS,
    })

    setBypassPayments({
        admin: eligibilityOverrideResponse?.administrative_fee === EligibilityCheck.BYPASS,
        valuation: eligibilityOverrideResponse?.valuation_fee === EligibilityCheck.BYPASS,
    })
 }, [eligibilityOverrideResponse])


 return {
    bypassSolicitors,
    bypassPayments,
    consentBypassNrics:
    eligibilityOverrideResponse?.individuals?.filter(
        (item) => item.consent_check === EligibilityCheck.BYPASS
      ).map(item => item.nric) ?? [],
    isFetched: isSuccess,
  };
}

export default useGetEligibilityOverride;
